import { useEffect, useState } from "react";
import { useAuthStore } from "../../../Stores/AuthStore";
import { useLocation, useNavigate } from "react-router-dom";
import { signIn } from "../../../Api/auth";
import { publicApi } from "../../../Api/api";

export default function Login() {

  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { setAuth } = useAuthStore();

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const result = await signIn({ email, password });
    if (result.data.user && result.data.access_token) {
      console.log("result.data.user", result.data.user);
      // return;
      setAuth(result.data.access_token , result.data.user);
      navigate(location.state?.from?.pathname || "/", { replace: true });
    }
  };

  useEffect(() => {
    if (location.state?.access_token) {
      setIsLoading(true);
      (async () => {
        const result = await publicApi.get("/auth/profile", {
          headers: {
            Authorization: `Bearer ${location.state?.access_token}`
          }
        });
        const user = result.data;
        setAuth(location.state?.access_token, user);
        navigate(location.state?.from?.pathname || "/", { replace: true });
      })();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state?.access_token]);

  if (isLoading) {
    return <div>Loading...</div>
  }

  return (
    <>
      <h1>Login</h1>
      <form onSubmit={onSubmit}>
        <input type="text" placeholder="email" value={email} onChange={e => setEmail(e.target.value)} />
        <input type="password" placeholder="password" value={password} onChange={e => setPassword(e.target.value)} />
        <button type="submit">Login</button>
      </form>
    </>
  )
}